const GET_ALL_WORKFLOW_REQUESTS = "/common/workflows";
const GET_USER_WORKFLOW_REQUESTS = "/common/workflows/self-requests";
const PROCESS_WORKFLOW_REQUEST = "/common/workflows/process-workflow-request";

export const WORKFLOW_ROUTES = {
  GET_ALL_WORKFLOW_REQUESTS,
  GET_USER_WORKFLOW_REQUESTS,
  PROCESS_WORKFLOW_REQUEST,
};
